module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<section class="result-box montana hidden" data-id="'+
((__t=( result.id ))==null?'':__t)+
'">\n	\n	';
 var item = result.classes[0] 
__p+='\n	\n	<div class="inner item" data-id="'+
((__t=( item.id ))==null?'':__t)+
'" data-item="'+
((__t=( item.item ))==null?'':__t)+
'">\n\n		<div class="row1">\n\n			<div class="image" style="background-image: url(https://'+
((__t=( window.Tramino.cdn || 'tramino.s3.amazonaws.com' ))==null?'':__t)+
''+
((__t=( item.image ))==null?'':__t)+
')"></div>\n		\n			';
 if ( item.price ) {  
__p+='\n			<div class="price" title="';
 if ( item.inkl ) print("inkl. " + item.inkl + ", ") 
__p+=' '+
((__t=( __('add_spa_tax') ))==null?'':__t)+
'">\n				';
 if ( result.booking == 1 ) { 
__p+='<span class="booking">'+
((__t=( __("result_book_online") ))==null?'':__t)+
'</span>';
 } 
__p+='\n				<span class="digits">'+
((__t=( Math.round( parseFloat(item.price) )  ))==null?'':__t)+
'</span>\n				<span class="currency">€</span>\n			</div>\n			';
 } 
__p+='\n\n		</div>\n\n		<div class="row2">\n\n			<div class="col col1">\n				\n				<h2 class="name">\n					'+
((__t=( item.name ))==null?'':__t)+
'\n				</h2>\n				\n				';
 if ( hasTag(result, 62004) ) { 
__p+='<div class="fact">'+
((__t=( tagName(62004) ))==null?'':__t)+
'</div>';
 } // Bergbahnen Unlimited 
__p+='\n				';
 if ( hasTag(result, 49243) ) { 
__p+='<div class="fact">'+
((__t=( tagName(49243) ))==null?'':__t)+
'</div>';
 } // Sauna/Hallenbad 
__p+='\n				';
 if ( hasTag(result, 7166) ) { 
__p+='<div class="fact">'+
((__t=( tagName(7166) ))==null?'':__t)+
'</div>';
 } // WLAN 
__p+='\n\n\n			</div>\n\n			<div class="col col2">	\n\n				<div class="haus"></div>\n				<div class="location">\n					<a href="'+
((__t=( registry('PartnerBase') ))==null?'':__t)+
''+
((__t=( result.shortcut ))==null?'':__t)+
'.html">\n					';
 if ( result.name.match('Huth') ) { 
__p+='\n						Montana Ferienwohnungen<br>\n					';
 } else if ( result.street == 'Trettachstraße 17' ) { 
__p+='\n						Montana Haus<br>\n					';
 } else { 
__p+='\n						'+
((__t=( result.name ))==null?'':__t)+
'<br>\n					';
 } 
__p+='\n					</a>\n					';
 if ( ! result.name.match('Huth') ) { 
__p+='\n						'+
((__t=( result.street ))==null?'':__t)+
' <br>\n						'+
((__t=( result.plz ))==null?'':__t)+
' '+
((__t=( result.ort ))==null?'':__t)+
' ';
 if ( result.district ) { 
__p+=' / ';
 } 
__p+=' '+
((__t=( result.district ))==null?'':__t)+
'\n					';
 } 
__p+='\n				</div>\n\n				';
 
					var facts = new Array();
					if ( hasTag(result, 13915) ) { facts.push(tagName(13915)) } // Garage/Tiefgarage
					if ( hasTag(result, 1692) ) { facts.push(tagName(1692)) } // Balkon
					if ( hasTag(result, 2849) ) { facts.push(tagName(2849)) } // Terrasse
				
__p+='\n\n				<div class="info">\n					'+
((__t=( item.facts ))==null?'':__t)+
'';
 if ( facts.length > 0 ) { 
__p+=', '+
((__t=( facts.join(", ") ))==null?'':__t)+
'';
 } 
__p+='\n					';
 console.log(item.tags) 
__p+='\n				</div>\n\n			\n\n			</div>\n			<div class="clear"></div>\n		</div>\n	</div>\n</section>\n\n';
}
return __p;
};


//////////////////
// WEBPACK FOOTER
// /Users/bm/app/code/jsapps/modules/reserva/templates/engine/result-template-montana.html
// module id = 80
// module chunks = 0